import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import VisitorTracker from "@/components/VisitorTracker";
import AdminLayout from "@/components/AdminLayout";
import InstituteLayout from "@/components/InstituteLayout";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import InfraDashboard from "@/pages/admin/InfraDashboard";
import VehicleAdminDashboard from "@/pages/admin/VehicleAdminDashboard";
import Vehicles from "@/pages/admin/Vehicles";
import Drivers from "@/pages/admin/Drivers";
import TrustDetails from "@/pages/admin/TrustDetails";
import Institutes from "@/pages/admin/Institutes";
import Masters from "@/pages/admin/Masters";
import ChangePassword from "@/pages/admin/ChangePassword";
import ExecutiveBody from "@/pages/admin/ExecutiveBody";
import GeneralBody from "@/pages/admin/GeneralBody";
import BankAccounts from "@/pages/admin/BankAccounts";
import TrustDocuments from "@/pages/admin/TrustDocuments";
import InstituteBanks from "@/pages/admin/InstituteBanks";
import AllInstituteBanks from "@/pages/admin/AllInstituteBanks";
import ImmovableAssets from "@/pages/admin/Properties";
import UnitItems from "@/pages/admin/properties/UnitItems";
import FinancialDocuments from "@/pages/admin/FinancialDocuments";
import Gallery from "@/pages/admin/Gallery";
import Employees from "@/pages/admin/Employees";
import Meetings from "@/pages/admin/Meetings";
import Users from "@/pages/admin/Users";
import AcademicReports from "@/pages/admin/AcademicReports";

import InstituteLogin from "@/pages/institute/InstituteLogin";
import InstituteDashboard from "@/pages/institute/InstituteDashboard";
import Departments from "@/pages/institute/Departments";
import Courses from "@/pages/institute/Courses";
import Intake from "@/pages/institute/Intake";
import Fees from "@/pages/institute/Fees";
import InstituteStaff from "@/pages/institute/InstituteStaff";
import InstituteGallery from "@/pages/institute/InstituteGallery";
import InstituteLinks from "@/pages/institute/InstituteLinks";
import InstituteNotices from "@/pages/institute/InstituteNotices";
import InstituteAdmissionNotices from "@/pages/institute/InstituteAdmissionNotices";
import InstituteAdmissionInquiries from "@/pages/institute/InstituteAdmissionInquiries";
import InstituteJobs from "@/pages/institute/InstituteJobs";
import PublicCareersPage from "@/components/PublicCareersPage";
import InstituteScroller from "@/pages/institute/InstituteScroller";
import InstituteInfo from "@/pages/institute/InstituteInfo";
import InstituteMandatoryDisclosure from "@/pages/institute/InstituteMandatoryDisclosure";
import InstituteSocialMedia from "@/pages/institute/InstituteSocialMedia";
import InstituteHomeFeatures from "@/pages/institute/InstituteHomeFeatures";
import LeadershipMessages from "@/pages/institute/LeadershipMessages";
import GoverningBody from "@/pages/institute/GoverningBody";
import Academics from "@/pages/institute/Academics";
import Facilities from "@/pages/institute/Facilities";
import Alumni from "@/pages/institute/Alumni";
import EventsAchievements from "@/pages/institute/EventsAchievements";
import Committees from "@/pages/institute/Committees";
import HeaderSlider from "@/pages/institute/HeaderSlider";
import InstitutePortalBanks from "@/pages/institute/InstituteBanks";
import InstitutePortalMovables from "@/pages/institute/MovableItems";
import InstitutePortalFraFfc from "@/pages/institute/FraFfc";
import InstitutePortalNaac from "@/pages/institute/NaacDocuments";
import InstitutePortalAlumniRegistrations from "@/pages/institute/AlumniRegistrations";

import PolyLayout from "@/pages/public/polyaurangabad/PolyLayout";
import PolyHome from "@/pages/public/polyaurangabad/Home";
import PolyAbout from "@/pages/public/polyaurangabad/About";
import PolyVisionMission from "@/pages/public/polyaurangabad/VisionMission";
import PolyLeadership from "@/pages/public/polyaurangabad/Leadership";
import PolyDepartments from "@/pages/public/polyaurangabad/Departments";
import PolyEngagements from "@/pages/public/polyaurangabad/CampusEngagements";
import PolyCommittees from "@/pages/public/polyaurangabad/Committees";
import PolyGallery from "@/pages/public/polyaurangabad/Gallery";
import PolyLinks from "@/pages/public/polyaurangabad/ImportantLinks";
import PolyNotices from "@/pages/public/polyaurangabad/Notices";
import PolyAdmissions from "@/pages/public/polyaurangabad/Admissions";
import PolyFacilities from "@/pages/public/polyaurangabad/Facilities";
import PolyContact from "@/pages/public/polyaurangabad/Contact";
import PolyAcademics from "@/pages/public/polyaurangabad/AcademicsPage";
import PolyGBPage from "@/pages/public/polyaurangabad/GoverningBodyPage";
import PolyEBPage from "@/pages/public/polyaurangabad/ExecutiveBodyPage";
import PolyFees from "@/pages/public/polyaurangabad/Fees";

// Shared public components — Alumni Registration + FRA/FFC listing for all institutes
import AlumniRegistrationForm from "@/components/AlumniRegistrationForm";
import FraFfcPublicPage from "@/components/FraFfcPublicPage";
import NaacPublicPage from "@/components/NaacPublicPage";
import AlumniPublicPage from "@/components/AlumniPublicPage";
const AlumniReg = ({ slug }) => <AlumniRegistrationForm slug={slug} />;
const FraFfc = ({ slug }) => <FraFfcPublicPage slug={slug} />;
const Naac = ({ slug }) => <NaacPublicPage slug={slug} />;
const AlumniList = ({ slug }) => <AlumniPublicPage slug={slug} />;

import BulLayout from "@/pages/public/bulandshahr/BulLayout";
import BulHome from "@/pages/public/bulandshahr/Home";
import BulAbout from "@/pages/public/bulandshahr/About";
import BulVisionMission from "@/pages/public/bulandshahr/VisionMission";
import BulLeadership from "@/pages/public/bulandshahr/Leadership";
import BulDepartments from "@/pages/public/bulandshahr/Departments";
import BulEngagements from "@/pages/public/bulandshahr/CampusEngagements";
import BulCommittees from "@/pages/public/bulandshahr/Committees";
import BulGallery from "@/pages/public/bulandshahr/Gallery";
import BulLinks from "@/pages/public/bulandshahr/ImportantLinks";
import BulNotices from "@/pages/public/bulandshahr/Notices";
import BulAdmissions from "@/pages/public/bulandshahr/Admissions";
import BulFacilities from "@/pages/public/bulandshahr/Facilities";
import BulContact from "@/pages/public/bulandshahr/Contact";
import BulAcademics from "@/pages/public/bulandshahr/AcademicsPage";
import BulGBPage from "@/pages/public/bulandshahr/GoverningBodyPage";
import BulEBPage from "@/pages/public/bulandshahr/ExecutiveBodyPage";

import RoeLayout from "@/pages/public/polyrotegaon/RoeLayout";
import RoeHome from "@/pages/public/polyrotegaon/Home";
import RoeAbout from "@/pages/public/polyrotegaon/About";
import RoeVisionMission from "@/pages/public/polyrotegaon/VisionMission";
import RoeLeadership from "@/pages/public/polyrotegaon/Leadership";
import RoeDepartments from "@/pages/public/polyrotegaon/Departments";
import RoeEngagements from "@/pages/public/polyrotegaon/CampusEngagements";
import RoeCommittees from "@/pages/public/polyrotegaon/Committees";
import RoeGallery from "@/pages/public/polyrotegaon/Gallery";
import RoeLinks from "@/pages/public/polyrotegaon/ImportantLinks";
import RoeNotices from "@/pages/public/polyrotegaon/Notices";
import RoeAdmissions from "@/pages/public/polyrotegaon/Admissions";
import RoeFacilities from "@/pages/public/polyrotegaon/Facilities";
import RoeContact from "@/pages/public/polyrotegaon/Contact";
import RoeAcademics from "@/pages/public/polyrotegaon/AcademicsPage";
import RoeGBPage from "@/pages/public/polyrotegaon/GoverningBodyPage";
import RoeEBPage from "@/pages/public/polyrotegaon/ExecutiveBodyPage";
import RoeFees from "@/pages/public/polyrotegaon/Fees";

import MitsolLayout from "@/pages/public/mitsolapur/MitsolLayout";
import MitsolHome from "@/pages/public/mitsolapur/Home";
import MitsolAbout from "@/pages/public/mitsolapur/About";
import MitsolLeadership from "@/pages/public/mitsolapur/Leadership";
import MitsolExecutiveBody from "@/pages/public/mitsolapur/ExecutiveBody";
import MitsolTrades from "@/pages/public/mitsolapur/Trades";
import MitsolFacilities from "@/pages/public/mitsolapur/Facilities";
import MitsolActivities from "@/pages/public/mitsolapur/Activities";
import MitsolContact from "@/pages/public/mitsolapur/Contact";
import MitsolGallery from "@/pages/public/mitsolapur/Gallery";
import MitsolFees from "@/pages/public/mitsolapur/Fees";

import MitcidcoLayout from "@/pages/public/mititicidco/MitcidcoLayout";
import MitcidcoHome from "@/pages/public/mititicidco/Home";
import MitcidcoAbout from "@/pages/public/mititicidco/About";
import MitcidcoLeadership from "@/pages/public/mititicidco/Leadership";
import MitcidcoExecutiveBody from "@/pages/public/mititicidco/ExecutiveBody";
import MitcidcoTrades from "@/pages/public/mititicidco/Trades";
import MitcidcoFacilities from "@/pages/public/mititicidco/Facilities";
import MitcidcoActivities from "@/pages/public/mititicidco/Activities";
import MitcidcoContact from "@/pages/public/mititicidco/Contact";
import MitcidcoGallery from "@/pages/public/mititicidco/Gallery";
import MitcidcoFees from "@/pages/public/mititicidco/Fees";

import MitmcvcLayout from "@/pages/public/mitmcvc/MitmcvcLayout";
import MitmcvcHome from "@/pages/public/mitmcvc/Home";
import MitmcvcAbout from "@/pages/public/mitmcvc/About";
import MitmcvcLeadership from "@/pages/public/mitmcvc/Leadership";
import MitmcvcExecutiveBody from "@/pages/public/mitmcvc/ExecutiveBody";
import MitmcvcGallery from "@/pages/public/mitmcvc/Gallery";
import MitmcvcContact from "@/pages/public/mitmcvc/Contact";

import MitestLayout from "@/pages/public/mitest/PolyLayout";
import MitestHome from "@/pages/public/mitest/Home";
import MitestAbout from "@/pages/public/mitest/About";
import MitestVisionMission from "@/pages/public/mitest/VisionMission";
import MitestLeadership from "@/pages/public/mitest/Leadership";
import MitestDepartments from "@/pages/public/mitest/Departments";
import MitestEngagements from "@/pages/public/mitest/CampusEngagements";
import MitestCommittees from "@/pages/public/mitest/Committees";
import MitestGallery from "@/pages/public/mitest/Gallery";
import MitestLinks from "@/pages/public/mitest/ImportantLinks";
import MitestNotices from "@/pages/public/mitest/Notices";
import MitestAdmissions from "@/pages/public/mitest/Admissions";
import MitestFacilities from "@/pages/public/mitest/Facilities";
import MitestContact from "@/pages/public/mitest/Contact";
import MitestAcademics from "@/pages/public/mitest/AcademicsPage";
import MitestGBPage from "@/pages/public/mitest/GoverningBodyPage";
import MitestEBPage from "@/pages/public/mitest/ExecutiveBodyPage";

import FoodLayout from "@/pages/public/foodtech/FoodLayout";
import FoodHome from "@/pages/public/foodtech/Home";
import FoodAbout from "@/pages/public/foodtech/About";
import FoodVisionMission from "@/pages/public/foodtech/VisionMission";
import FoodLeadership from "@/pages/public/foodtech/Leadership";
import FoodDepartments from "@/pages/public/foodtech/Departments";
import FoodEngagements from "@/pages/public/foodtech/CampusEngagements";
import FoodCommittees from "@/pages/public/foodtech/Committees";
import FoodGallery from "@/pages/public/foodtech/Gallery";
import FoodLinks from "@/pages/public/foodtech/ImportantLinks";
import FoodNotices from "@/pages/public/foodtech/Notices";
import FoodAdmissions from "@/pages/public/foodtech/Admissions";
import FoodFacilities from "@/pages/public/foodtech/Facilities";
import FoodContact from "@/pages/public/foodtech/Contact";
import FoodAcademics from "@/pages/public/foodtech/AcademicsPage";
import FoodGBPage from "@/pages/public/foodtech/GoverningBodyPage";
import FoodEBPage from "@/pages/public/foodtech/ExecutiveBodyPage";

import CidcoLayout from "@/pages/public/cidco/CidcoLayout";
import CidcoHome from "@/pages/public/cidco/Home";
import CidcoAbout from "@/pages/public/cidco/About";
import CidcoVisionMission from "@/pages/public/cidco/VisionMission";
import CidcoLeadership from "@/pages/public/cidco/Leadership";
import CidcoDepartments from "@/pages/public/cidco/Departments";
import CidcoEngagements from "@/pages/public/cidco/CampusEngagements";
import CidcoCommittees from "@/pages/public/cidco/Committees";
import CidcoGallery from "@/pages/public/cidco/Gallery";
import CidcoLinks from "@/pages/public/cidco/ImportantLinks";
import CidcoNotices from "@/pages/public/cidco/Notices";
import CidcoAdmissions from "@/pages/public/cidco/Admissions";
import CidcoFacilities from "@/pages/public/cidco/Facilities";
import CidcoContact from "@/pages/public/cidco/Contact";
import CidAcademics from "@/pages/public/cidco/AcademicsPage";
import CidGBPage from "@/pages/public/cidco/GoverningBodyPage";
import CidEBPage from "@/pages/public/cidco/ExecutiveBodyPage";

import NursingLayout from "@/pages/public/nursing/NursingLayout";
import NursingHome from "@/pages/public/nursing/Home";
import NursingAbout from "@/pages/public/nursing/About";
import NursingVisionMission from "@/pages/public/nursing/VisionMission";
import NursingLeadership from "@/pages/public/nursing/Leadership";
import NursingDepartments from "@/pages/public/nursing/Departments";
import NursingEngagements from "@/pages/public/nursing/CampusEngagements";
import NursingCommittees from "@/pages/public/nursing/Committees";
import NursingGallery from "@/pages/public/nursing/Gallery";
import NursingLinks from "@/pages/public/nursing/ImportantLinks";
import NursingNotices from "@/pages/public/nursing/Notices";
import NursingAdmissions from "@/pages/public/nursing/Admissions";
import NursingFacilities from "@/pages/public/nursing/Facilities";
import NursingContact from "@/pages/public/nursing/Contact";
import NurAcademics from "@/pages/public/nursing/AcademicsPage";
import NurGBPage from "@/pages/public/nursing/GoverningBodyPage";
import NurEBPage from "@/pages/public/nursing/ExecutiveBodyPage";

import SchoolLayout, { SchoolHome, SchoolAbout, SchoolContact, SchoolGallery, SchoolAcademics } from "@/pages/public/mitschool/SchoolApp";
import JirtLayout, { JirtHome, JirtAbout, JirtContact, JirtGallery, JirtAcademics } from "@/pages/public/jirt/JirtApp";
import TrustLayout, { TrustHome, TrustOverview, TrustPioneers, TrustTrustees, TrustInstitutes, TrustTeam, TrustGallery, TrustContact, TrustCareers, TrustFees, TrustSocialImpact, TrustAmenities } from "@/pages/public/trust/TrustApp";
import TrustMemories, { TrustMemoriesSubmit } from "@/pages/public/trust/TrustMemories";
import TrustVendorRegister, { TrustVendorThankYou } from "@/pages/public/trust/TrustVendorRegister";
import BookAmenity, { BookAmenityConfirmation } from "@/pages/public/trust/BookAmenity";
import VendorLogin from "@/pages/vendor/VendorLogin";
import VendorLayout from "@/pages/vendor/VendorLayout";
import VendorDashboard from "@/pages/vendor/VendorDashboard";
import VendorDocuments from "@/pages/vendor/VendorDocuments";
import VendorTenders from "@/pages/vendor/VendorTenders";
import VendorPayment from "@/pages/vendor/VendorPayment";
import VendorAccount from "@/pages/vendor/VendorAccount";
import TrustTendersList, { TrustTenderDetail } from "@/pages/public/trust/TrustTenders";
import Pioneers from "@/pages/admin/Pioneers";
import NewsEvents from "@/pages/admin/NewsEvents";
import AdminMemories from "@/pages/admin/Memories";
import AdminSocialImpact from "@/pages/admin/SocialImpact";
import AdminAmenities from "@/pages/admin/Amenities";
import AdminAmenityBookings from "@/pages/admin/AmenityBookings";
import AdminAmenityVouchers from "@/pages/admin/AmenityVouchers";
import VendorEmpanelment from "@/pages/admin/VendorEmpanelment";
import TenderManagement from "@/pages/admin/TenderManagement";
import AdminPayments from "@/pages/admin/Payments";
import HeroSlides from "@/pages/admin/HeroSlides";
import Analytics from "@/pages/admin/Analytics";
import FeeStructures from "@/pages/admin/FeeStructures";
import AdmissionInquiries from "@/pages/admin/AdmissionInquiries";
import JobApplications from "@/pages/admin/JobApplications";
import AdminJobs from "@/pages/admin/Jobs";
import MarathonRuns from "@/pages/admin/MarathonRuns";
import MarathonRegistrations from "@/pages/admin/MarathonRegistrations";
import RunRegister from "@/pages/public/run/RunRegister";
import RunStatus from "@/pages/public/run/RunStatus";
import MarathonLandingPage from "@/pages/public/run/MarathonLandingPage";
import MarathonLanding from "@/pages/admin/MarathonLanding";

const guard = (module, element) => (
  <ProtectedRoute requireModule={module}>{element}</ProtectedRoute>
);

// Render a role-specific landing page under `/admin`.
function DashboardRouter() {
  const { user } = useAuth();
  if (user?.role === "infrastructure") return <InfraDashboard />;
  if (user?.role === "vehicle_admin") return <VehicleAdminDashboard />;
  return <Dashboard />;
}

function InstituteGuard({ children, adminOnly }) {
  const { user, loading, role } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f9f8f6]">
        <div className="font-serif text-2xl text-[#234333]">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/institute/login" replace />;
  if (role === "institute_staff") {
    // Institute Staff role is retained for legacy reasons but no longer has portal access.
    return <Navigate to="/institute/login?denied=staff" replace />;
  }
  if (role !== "institute_admin") {
    return <Navigate to="/admin" replace />;
  }
  if (adminOnly && role !== "institute_admin") {
    return (
      <div className="p-12 max-w-2xl mx-auto bg-white border border-[#e5e0d8] rounded-sm mt-12 text-center">
        <div className="font-serif text-3xl text-[#1c1a17] mb-3">Access Denied</div>
        <div className="text-sm text-[#6b655b]">
          Only Institute Admins can access this page. Contact your Institute Admin if you need
          access.
        </div>
      </div>
    );
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <VisitorTracker />
          <Routes>
            <Route path="/admin/login" element={<Login />} />
            <Route path="/login" element={<Navigate to="/admin/login" replace />} />
            <Route path="/institute/login" element={<InstituteLogin />} />

            {/* Trust admin */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardRouter />} />
              <Route path="trust" element={guard("trust", <TrustDetails />)} />
              <Route path="executive-body" element={guard("executive_body", <ExecutiveBody />)} />
              <Route path="general-body" element={guard("general_body", <GeneralBody />)} />
              <Route path="meetings" element={guard("meetings", <Meetings />)} />
              <Route path="banks" element={guard("banks", <BankAccounts />)} />
              <Route path="banks/institutes" element={guard("banks", <AllInstituteBanks />)} />
              <Route path="documents" element={guard("documents", <TrustDocuments />)} />
              <Route path="immovables" element={<Navigate to="/admin/properties" replace />} />
              <Route path="properties" element={guard("immovables", <ImmovableAssets />)} />
              <Route path="properties/units/:unitId/items" element={guard("immovables", <UnitItems />)} />
              <Route path="financials" element={guard("financials", <FinancialDocuments />)} />
              <Route path="gallery" element={guard("gallery", <Gallery />)} />
              <Route path="pioneers" element={<Pioneers />} />
              <Route path="news-events" element={<NewsEvents />} />
              <Route path="memories" element={<AdminMemories />} />
              <Route path="social-impact" element={<AdminSocialImpact />} />
              <Route path="vendors" element={<VendorEmpanelment />} />
              <Route path="tenders" element={<TenderManagement />} />
              <Route path="payments" element={<AdminPayments />} />
              <Route path="hero-slides" element={<HeroSlides />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="marathon-runs" element={<MarathonRuns />} />
              <Route path="marathon-landing" element={<MarathonLanding />} />
              <Route path="marathon-registrations" element={<MarathonRegistrations />} />
              <Route path="fee-structures" element={<FeeStructures />} />
              <Route path="admission-inquiries" element={<AdmissionInquiries />} />
              <Route path="job-applications" element={<JobApplications />} />
              <Route path="jobs" element={<AdminJobs />} />
              <Route path="employees" element={guard("employees", <Employees />)} />
              <Route path="institutes" element={guard("institutes", <Institutes />)} />
              <Route
                path="institutes/:instituteId/banks"
                element={guard("banks", <InstituteBanks />)}
              />
              <Route path="masters" element={guard("masters", <Masters />)} />
              <Route path="vehicles" element={guard("vehicles", <Vehicles />)} />
              <Route path="drivers" element={guard("vehicles", <Drivers />)} />
              <Route path="amenities" element={guard("amenities", <AdminAmenities />)} />
              <Route path="amenity-bookings" element={guard("amenities", <AdminAmenityBookings />)} />
              <Route path="amenity-vouchers" element={guard("amenities", <AdminAmenityVouchers />)} />
              <Route path="academic" element={<AcademicReports />} />
              <Route
                path="users"
                element={
                  <ProtectedRoute requireUserMgmt>
                    <Users />
                  </ProtectedRoute>
                }
              />
              <Route path="change-password" element={<ChangePassword />} />
            </Route>

            {/* Institute portal */}
            <Route
              path="/institute"
              element={
                <InstituteGuard>
                  <InstituteLayout />
                </InstituteGuard>
              }
            >
              <Route index element={<InstituteDashboard />} />
              <Route path="courses" element={<Courses />} />
              <Route path="departments" element={<Departments />} />
              <Route path="intake" element={<Intake />} />
              <Route path="fees" element={<Fees />} />
              <Route path="gallery" element={<InstituteGallery />} />
              <Route path="links" element={<InstituteLinks />} />
              <Route path="notices" element={<InstituteNotices />} />
              <Route path="admission-notices" element={<InstituteAdmissionNotices />} />
              <Route path="admission-inquiries" element={<InstituteAdmissionInquiries />} />
              <Route path="jobs" element={<InstituteJobs />} />
              <Route path="scroller" element={<InstituteScroller />} />
              <Route path="mandatory-disclosure" element={<InstituteMandatoryDisclosure />} />
              <Route path="social-media" element={<InstituteSocialMedia />} />
              <Route path="home-features" element={<InstituteHomeFeatures />} />
              <Route path="leadership" element={<LeadershipMessages />} />
              <Route path="governing-body" element={<GoverningBody />} />
              <Route path="academics" element={<Academics />} />
              <Route path="facilities" element={<Facilities />} />
              <Route path="alumni" element={<Alumni />} />
              <Route path="events" element={<EventsAchievements />} />
              <Route path="committees" element={<Committees />} />
              <Route path="header-slider" element={<HeaderSlider />} />
              <Route path="info" element={<InstituteInfo />} />
              <Route path="banks" element={<InstitutePortalBanks />} />
              <Route path="movable-items" element={<InstitutePortalMovables />} />
              <Route path="fra-ffc" element={<InstitutePortalFraFfc />} />
              <Route path="naac" element={<InstitutePortalNaac />} />
              <Route path="alumni-registrations" element={<InstitutePortalAlumniRegistrations />} />
              <Route
                path="staff"
                element={
                  <InstituteGuard adminOnly>
                    <InstituteStaff />
                  </InstituteGuard>
                }
              />
              <Route path="change-password" element={<ChangePassword />} />
            </Route>

            {/* Vendor Portal (post-approval) */}
            <Route path="/vendor/login" element={<VendorLogin />} />
            <Route path="/vendor/portal" element={<VendorLayout />}>
              <Route index element={<VendorDashboard />} />
              <Route path="documents" element={<VendorDocuments />} />
              <Route path="tenders" element={<VendorTenders />} />
              <Route path="payment" element={<VendorPayment />} />
              <Route path="account" element={<VendorAccount />} />
            </Route>
            <Route path="/vendor" element={<Navigate to="/vendor/login" replace />} />

            {/* Public Amenity Booking flow — full-screen, no Trust nav */}
            <Route path="/marathon" element={<MarathonLandingPage />} />
            <Route path="/run/register" element={<RunRegister />} />
            <Route path="/run/register/status/:token" element={<RunStatus />} />
            <Route path="/book-amenity/:amenityId" element={<BookAmenity />} />
            <Route path="/book-amenity/confirmation/:bookingRef" element={<BookAmenityConfirmation />} />

            <Route path="/" element={<TrustLayout />}>
              <Route index element={<TrustHome />} />
              <Route path="overview" element={<TrustOverview />} />
              <Route path="pioneers" element={<TrustPioneers />} />
              <Route path="trustees" element={<TrustTrustees />} />
              <Route path="institutes" element={<TrustInstitutes />} />
              <Route path="our-team" element={<TrustTeam />} />
              <Route path="gallery" element={<TrustGallery />} />
              <Route path="careers" element={<TrustCareers />} />
              <Route path="fees" element={<TrustFees />} />
              <Route path="memories" element={<TrustMemories />} />
              <Route path="memories/submit" element={<TrustMemoriesSubmit />} />
              <Route path="social-impact" element={<TrustSocialImpact />} />
              <Route path="amenities" element={<TrustAmenities />} />
              <Route path="vendors/register" element={<TrustVendorRegister />} />
              <Route path="vendors/thank-you" element={<TrustVendorThankYou />} />
              <Route path="tenders" element={<TrustTendersList />} />
              <Route path="tenders/:id" element={<TrustTenderDetail />} />
              <Route path="contact" element={<TrustContact />} />
            </Route>
            {/* Public institute website — polyaurangabad */}
            <Route path="/polyaurangabad" element={<PolyLayout />}>
              <Route index element={<PolyHome />} />
              <Route path="about" element={<PolyAbout />} />
              <Route path="vision-mission" element={<PolyVisionMission />} />
              <Route path="leadership" element={<PolyLeadership />} />
              <Route path="departments" element={<PolyDepartments />} />
              <Route path="departments/:slug" element={<PolyDepartments />} />
              <Route path="campus-engagements" element={<PolyEngagements />} />
              <Route path="campus-engagements/:typeSlug" element={<PolyEngagements />} />
              <Route path="committees" element={<PolyCommittees />} />
              <Route path="gallery" element={<PolyGallery />} />
              <Route path="links" element={<PolyLinks />} />
              <Route path="notices" element={<PolyNotices />} />
              <Route path="admissions" element={<PolyAdmissions />} />
              <Route path="facilities" element={<PolyFacilities />} />
              <Route path="contact" element={<PolyContact />} />
              <Route path="academics" element={<PolyAcademics />} />
              <Route path="governing-body" element={<PolyGBPage />} />
              <Route path="executive-body" element={<PolyEBPage />} />
              <Route path="alumni" element={<AlumniList slug="polyaurangabad" />} />
              <Route path="alumni/register" element={<AlumniReg slug="polyaurangabad" />} />
              <Route path="careers" element={<PublicCareersPage slug="polyaurangabad" testidPrefix="poly-careers" theme="navy" />} />
              <Route path="fra-ffc" element={<FraFfc slug="polyaurangabad" />} />
              <Route path="naac" element={<Naac slug="polyaurangabad" />} />
              <Route path="fees" element={<PolyFees />} />
            </Route>
            {/* Public institute website — bulandshahr (MIT Engineering College, UP) */}
            <Route path="/bulandshahr" element={<BulLayout />}>
              <Route index element={<BulHome />} />
              <Route path="about" element={<BulAbout />} />
              <Route path="vision-mission" element={<BulVisionMission />} />
              <Route path="leadership" element={<BulLeadership />} />
              <Route path="departments" element={<BulDepartments />} />
              <Route path="departments/:slug" element={<BulDepartments />} />
              <Route path="campus-engagements" element={<BulEngagements />} />
              <Route path="campus-engagements/:typeSlug" element={<BulEngagements />} />
              <Route path="committees" element={<BulCommittees />} />
              <Route path="gallery" element={<BulGallery />} />
              <Route path="links" element={<BulLinks />} />
              <Route path="notices" element={<BulNotices />} />
              <Route path="admissions" element={<BulAdmissions />} />
              <Route path="facilities" element={<BulFacilities />} />
              <Route path="contact" element={<BulContact />} />
              <Route path="academics" element={<BulAcademics />} />
              <Route path="governing-body" element={<BulGBPage />} />
              <Route path="executive-body" element={<BulEBPage />} />
              <Route path="alumni" element={<AlumniList slug="bulandshahr" />} />
              <Route path="alumni/register" element={<AlumniReg slug="bulandshahr" />} />
              <Route path="careers" element={<PublicCareersPage slug="bulandshahr" testidPrefix="bul-careers" theme="cream" />} />
              <Route path="fra-ffc" element={<FraFfc slug="bulandshahr" />} />
              <Route path="naac" element={<Naac slug="bulandshahr" />} />
            </Route>
            {/* Public institute website — polyrotegaon (MIT Polytechnic, Rotegaon/Vaijapur) */}
            <Route path="/polyrotegaon" element={<RoeLayout />}>
              <Route index element={<RoeHome />} />
              <Route path="about" element={<RoeAbout />} />
              <Route path="vision-mission" element={<RoeVisionMission />} />
              <Route path="leadership" element={<RoeLeadership />} />
              <Route path="departments" element={<RoeDepartments />} />
              <Route path="departments/:slug" element={<RoeDepartments />} />
              <Route path="campus-engagements" element={<RoeEngagements />} />
              <Route path="campus-engagements/:typeSlug" element={<RoeEngagements />} />
              <Route path="committees" element={<RoeCommittees />} />
              <Route path="gallery" element={<RoeGallery />} />
              <Route path="links" element={<RoeLinks />} />
              <Route path="notices" element={<RoeNotices />} />
              <Route path="admissions" element={<RoeAdmissions />} />
              <Route path="facilities" element={<RoeFacilities />} />
              <Route path="contact" element={<RoeContact />} />
              <Route path="academics" element={<RoeAcademics />} />
              <Route path="governing-body" element={<RoeGBPage />} />
              <Route path="executive-body" element={<RoeEBPage />} />
              <Route path="alumni" element={<AlumniList slug="polyrotegaon" />} />
              <Route path="alumni/register" element={<AlumniReg slug="polyrotegaon" />} />
              <Route path="careers" element={<PublicCareersPage slug="polyrotegaon" testidPrefix="roe-careers" theme="navy" />} />
              <Route path="fra-ffc" element={<FraFfc slug="polyrotegaon" />} />
              <Route path="naac" element={<Naac slug="polyrotegaon" />} />
              <Route path="fees" element={<RoeFees />} />
            </Route>
            {/* Public institute website — mitsolapur (Marathwada ITI Solapur) */}
            <Route path="/mitsolapur" element={<MitsolLayout />}>
              <Route index element={<MitsolHome />} />
              <Route path="about" element={<MitsolAbout />} />
              <Route path="leadership" element={<MitsolLeadership />} />
              <Route path="executive-body" element={<MitsolExecutiveBody />} />
              <Route path="trades" element={<MitsolTrades />} />
              <Route path="facilities" element={<MitsolFacilities />} />
              <Route path="activities" element={<MitsolActivities />} />
              <Route path="gallery" element={<MitsolGallery />} />
              <Route path="contact" element={<MitsolContact />} />
              <Route path="careers" element={<PublicCareersPage slug="mitsolapur" testidPrefix="mitsol-careers" theme="navy" />} />
              <Route path="fees" element={<MitsolFees />} />
            </Route>
            {/* Public institute website — mititicidco (Marathwada Pvt. ITI, CIDCO) */}
            <Route path="/mititicidco" element={<MitcidcoLayout />}>
              <Route index element={<MitcidcoHome />} />
              <Route path="about" element={<MitcidcoAbout />} />
              <Route path="leadership" element={<MitcidcoLeadership />} />
              <Route path="executive-body" element={<MitcidcoExecutiveBody />} />
              <Route path="trades" element={<MitcidcoTrades />} />
              <Route path="facilities" element={<MitcidcoFacilities />} />
              <Route path="activities" element={<MitcidcoActivities />} />
              <Route path="gallery" element={<MitcidcoGallery />} />
              <Route path="contact" element={<MitcidcoContact />} />
              <Route path="careers" element={<PublicCareersPage slug="mititicidco" testidPrefix="mitcidco-careers" theme="amber" />} />
              <Route path="fees" element={<MitcidcoFees />} />
            </Route>
            {/* Public institute website — mitmcvc (MIT HSC Vocational MCVC Junior College) */}
            <Route path="/mitmcvc" element={<MitmcvcLayout />}>
              <Route index element={<MitmcvcHome />} />
              <Route path="about" element={<MitmcvcAbout />} />
              <Route path="leadership" element={<MitmcvcLeadership />} />
              <Route path="executive-body" element={<MitmcvcExecutiveBody />} />
              <Route path="gallery" element={<MitmcvcGallery />} />
              <Route path="contact" element={<MitmcvcContact />} />
            </Route>
            {/* Public institute website — mitest (MIT Institute of Emerging Science and Technology) */}
            <Route path="/mitest" element={<MitestLayout />}>
              <Route index element={<MitestHome />} />
              <Route path="about" element={<MitestAbout />} />
              <Route path="vision-mission" element={<MitestVisionMission />} />
              <Route path="leadership" element={<MitestLeadership />} />
              <Route path="departments" element={<MitestDepartments />} />
              <Route path="departments/:slug" element={<MitestDepartments />} />
              <Route path="campus-engagements" element={<MitestEngagements />} />
              <Route path="campus-engagements/:typeSlug" element={<MitestEngagements />} />
              <Route path="committees" element={<MitestCommittees />} />
              <Route path="gallery" element={<MitestGallery />} />
              <Route path="links" element={<MitestLinks />} />
              <Route path="notices" element={<MitestNotices />} />
              <Route path="admissions" element={<MitestAdmissions />} />
              <Route path="facilities" element={<MitestFacilities />} />
              <Route path="contact" element={<MitestContact />} />
              <Route path="academics" element={<MitestAcademics />} />
              <Route path="governing-body" element={<MitestGBPage />} />
              <Route path="executive-body" element={<MitestEBPage />} />
              <Route path="alumni" element={<AlumniList slug="mitest" />} />
              <Route path="alumni/register" element={<AlumniReg slug="mitest" />} />
              <Route path="careers" element={<PublicCareersPage slug="mitest" testidPrefix="mitest-careers" theme="navy" />} />
              <Route path="fra-ffc" element={<FraFfc slug="mitest" />} />
              <Route path="naac" element={<Naac slug="mitest" />} />
            </Route>
            {/* Public institute website — foodtech (MIT College of Food Technology) */}
            <Route path="/foodtech" element={<FoodLayout />}>
              <Route index element={<FoodHome />} />
              <Route path="about" element={<FoodAbout />} />
              <Route path="vision-mission" element={<FoodVisionMission />} />
              <Route path="leadership" element={<FoodLeadership />} />
              <Route path="departments" element={<FoodDepartments />} />
              <Route path="departments/:slug" element={<FoodDepartments />} />
              <Route path="campus-engagements" element={<FoodEngagements />} />
              <Route path="campus-engagements/:typeSlug" element={<FoodEngagements />} />
              <Route path="committees" element={<FoodCommittees />} />
              <Route path="gallery" element={<FoodGallery />} />
              <Route path="links" element={<FoodLinks />} />
              <Route path="notices" element={<FoodNotices />} />
              <Route path="admissions" element={<FoodAdmissions />} />
              <Route path="facilities" element={<FoodFacilities />} />
              <Route path="contact" element={<FoodContact />} />
              <Route path="academics" element={<FoodAcademics />} />
              <Route path="governing-body" element={<FoodGBPage />} />
              <Route path="executive-body" element={<FoodEBPage />} />
              <Route path="alumni" element={<AlumniList slug="foodtech" />} />
              <Route path="alumni/register" element={<AlumniReg slug="foodtech" />} />
              <Route path="careers" element={<PublicCareersPage slug="foodtech" testidPrefix="ft-careers" theme="green" />} />
              <Route path="fra-ffc" element={<FraFfc slug="foodtech" />} />
              <Route path="naac" element={<Naac slug="foodtech" />} />
            </Route>

            {/* Public institute website — cidco (Marathwada Institute of Technology, CIDCO) */}
            <Route path="/cidco" element={<CidcoLayout />}>
              <Route index element={<CidcoHome />} />
              <Route path="about" element={<CidcoAbout />} />
              <Route path="vision-mission" element={<CidcoVisionMission />} />
              <Route path="leadership" element={<CidcoLeadership />} />
              <Route path="departments" element={<CidcoDepartments />} />
              <Route path="departments/:slug" element={<CidcoDepartments />} />
              <Route path="campus-engagements" element={<CidcoEngagements />} />
              <Route path="campus-engagements/:typeSlug" element={<CidcoEngagements />} />
              <Route path="committees" element={<CidcoCommittees />} />
              <Route path="gallery" element={<CidcoGallery />} />
              <Route path="links" element={<CidcoLinks />} />
              <Route path="notices" element={<CidcoNotices />} />
              <Route path="admissions" element={<CidcoAdmissions />} />
              <Route path="facilities" element={<CidcoFacilities />} />
              <Route path="contact" element={<CidcoContact />} />
              <Route path="academics" element={<CidAcademics />} />
              <Route path="governing-body" element={<CidGBPage />} />
              <Route path="executive-body" element={<CidEBPage />} />
              <Route path="alumni" element={<AlumniList slug="cidco" />} />
              <Route path="alumni/register" element={<AlumniReg slug="cidco" />} />
              <Route path="careers" element={<PublicCareersPage slug="cidco" testidPrefix="cid-careers" theme="navy" />} />
              <Route path="fra-ffc" element={<FraFfc slug="cidco" />} />
              <Route path="naac" element={<Naac slug="cidco" />} />
            </Route>

            {/* Public institute website — nursing (MIT Nursing College) */}
            <Route path="/nursing" element={<NursingLayout />}>
              <Route index element={<NursingHome />} />
              <Route path="about" element={<NursingAbout />} />
              <Route path="vision-mission" element={<NursingVisionMission />} />
              <Route path="leadership" element={<NursingLeadership />} />
              <Route path="departments" element={<NursingDepartments />} />
              <Route path="departments/:slug" element={<NursingDepartments />} />
              <Route path="campus-engagements" element={<NursingEngagements />} />
              <Route path="campus-engagements/:typeSlug" element={<NursingEngagements />} />
              <Route path="committees" element={<NursingCommittees />} />
              <Route path="gallery" element={<NursingGallery />} />
              <Route path="links" element={<NursingLinks />} />
              <Route path="notices" element={<NursingNotices />} />
              <Route path="admissions" element={<NursingAdmissions />} />
              <Route path="facilities" element={<NursingFacilities />} />
              <Route path="contact" element={<NursingContact />} />
              <Route path="academics" element={<NurAcademics />} />
              <Route path="governing-body" element={<NurGBPage />} />
              <Route path="executive-body" element={<NurEBPage />} />
              <Route path="alumni" element={<AlumniList slug="nursing" />} />
              <Route path="alumni/register" element={<AlumniReg slug="nursing" />} />
              <Route path="careers" element={<PublicCareersPage slug="nursing" testidPrefix="nur-careers" theme="navy" />} />
              <Route path="fra-ffc" element={<FraFfc slug="nursing" />} />
              <Route path="naac" element={<Naac slug="nursing" />} />
            </Route>

            {/* Public institute website — mitschool (एम. आय. टी. तंत्रप्रशाला) — 3-page Marathi site */}
            <Route path="/mitschool" element={<SchoolLayout />}>
              <Route index element={<SchoolHome />} />
              <Route path="about" element={<SchoolAbout />} />
              <Route path="gallery" element={<SchoolGallery />} />
              <Route path="academics" element={<SchoolAcademics />} />
              <Route path="contact" element={<SchoolContact />} />
              <Route path="alumni" element={<AlumniList slug="mitschool" />} />
              <Route path="alumni/register" element={<AlumniReg slug="mitschool" />} />
            </Route>

            {/* Public institute website — jirt (जे.आय.आर.टी. तंत्र प्रशाला वाशी) — Marathi school site */}
            <Route path="/jirt" element={<JirtLayout />}>
              <Route index element={<JirtHome />} />
              <Route path="about" element={<JirtAbout />} />
              <Route path="gallery" element={<JirtGallery />} />
              <Route path="academics" element={<JirtAcademics />} />
              <Route path="contact" element={<JirtContact />} />
              <Route path="alumni" element={<AlumniList slug="jirt" />} />
              <Route path="alumni/register" element={<AlumniReg slug="jirt" />} />
              <Route path="fra-ffc" element={<FraFfc slug="jirt" />} />
              <Route path="naac" element={<Naac slug="jirt" />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
